var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWrench = function SvgIconWrench(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.36 15.482 7.6 20.997l-.05.054a3.254 3.254 0 1 1-4.547-4.652l5.515-4.76a6.99 6.99 0 0 1 9.22-9.08 1 1 0 0 1 .312 1.627l-3.557 3.55.297 1.474 1.475.297 3.549-3.557a1 1 0 0 1 1.627.313 6.99 6.99 0 0 1-9.08 9.219m3.034-11.47a4.99 4.99 0 0 0-4.77 7.399 1 1 0 0 1-.22 1.243L4.34 17.886a1.254 1.254 0 0 0 1.773 1.773l5.232-6.062a1 1 0 0 1 1.258-.213 4.99 4.99 0 0 0 7.385-4.778L17.302 11.3a1 1 0 0 1-.906.274l-2.653-.534a1 1 0 0 1-.783-.783l-.534-2.653a1 1 0 0 1 .274-.906z",
    clipRule: "evenodd"
  })));
};
export default SvgIconWrench;